import { Popover } from "~/sharedComponents/popover";

export const listInPopoverProps: React.ComponentProps<typeof Popover> = {
    // list in popup should not lock focus inside;
    // instead, it should be possible to navigate by "tab" to any focusable element in a list's row (e.g. additional row's action like "settings" or "delete") if exists,
    // or to the next focusable element on the page, if not.
    enforceFocus: false,
    // to handle case when an action inside the selected row was focused by "tab", and has just been disappeared on arrow "up"/"down".
    handleFocusedElementUnmounting: true,
};
